import Tooltip, { TooltipTrigger } from '@/components/atoms/Tooltip';

import type { PenTag } from './penTags';

import styles from './PenComparisonTable.module.scss';

/**
 * A pen tag as a button, so a keyboard or touch user opens its reason the way a pointer
 * does, as with the warning marker beside it: focus opens the tooltip, and pressing it
 * does nothing more. A title on a plain span reached only the pointer.
 */
export function PenTagButton(props: { tag: PenTag }) {
    const { tag } = props;
    // The shared tooltip portals the bubble into the body, so the table's scroll region neither
    // clips it nor grows around it.
    return (
        <Tooltip content={tag.title} placement="right" layout="fit">
            <TooltipTrigger className={styles.penTag} description={tag.title} data-pen-tag={tag.id}>
                {tag.label}
            </TooltipTrigger>
        </Tooltip>
    );
}
